import { StyleSheet, Platform, Dimensions } from 'react-native';
import styled from 'styled-components';

import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

const { fontSize } = Layout;

const { width } = Dimensions.get('window'),
    isDesktop = Platform.OS === 'web' && width > 720;

export default StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.white
    },
    loading: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1
    },
    headerBar: {
        paddingTop: Layout.gutterSmall,
        paddingBottom: Layout.gutterSmall,
        paddingRight: Layout.gutter
    },

    pageHeader: {
        flexDirection: 'column'
    },
    pageTitle: {
        fontSize: 22
    },
    pageDetail: {
        fontSize
    },
    orderDetailHeader: {
        borderBottomWidth: 0,
        paddingHorizontal: Layout.gutter,
        paddingVertical: Layout.gutterMedium
    },
    headerList: {
        paddingHorizontal: Layout.gutter,
        paddingTop: Layout.gutter,
        paddingBottom: Layout.gutter,
        backgroundColor: Colors.lightBlue,
        marginHorizontal: Layout.isDesktop ? Layout.gutter : 0,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    headerListInfo: {
        fontSize: 16,
        paddingTop: 4,
        color: Colors.black
    },
    headerListIcon: {
        paddingVertical: Layout.gutterSmall
    },

    listItemContainer: {
        marginHorizontal: Layout.isDesktop ? Layout.gutter : 0
    },
    listItem: {
        flex: 1,
        flexDirection: 'row',
        paddingTop: Layout.gutterMedium + 1,
        paddingBottom: Layout.gutterMedium + 2,
        paddingHorizontal: Layout.gutter,
        borderTopWidth: 1,
        borderTopColor: Colors.border,
        alignItems: 'center'
    },
    styleItemChecked: {
        backgroundColor: Colors.lightBlue
    },
    styleItemCheckedDark: {
        backgroundColor: Colors.lightBlueDark,
        borderTopColor: '#eeeeee',
        borderBottomColor: '#eeeeee'
    },
    itemAdd: {
        color: Colors.success
    },
    itemRemov: {
        color: Colors.danger
    },
    itemAddNormally: {
        color: Colors.darker
    },
    wrapItem: {
        flex: 1
    },
    image: {
        width: 40,
        height: 40,
        marginRight: Layout.gutter
    },
    headerLine: {
        flex: 1,
        flexDirection: 'row',
        fontSize: isDesktop ? 16 : 12
    },
    itemDetailLine: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: Layout.gutterMin
    },
    itemDescBox: {
        borderWidth: 0.7,
        borderRadius: 3,
        borderColor: '#DFDFDF33',
        backgroundColor: '#DFDFDF33'
    },
    itemInfo: {
        color: Colors.dark
    },
    itemIcon: {
        marginLeft: 10
    },
    itemMarginLeft: {
        marginLeft: Layout.gutterMin
    },
    itemInfoSep: {
        marginHorizontal: 10
    },
    itemName: {
        flex: 7
    },
    text: {
        fontSize
    },
    itemValue: {
        flex: 2
    },
    totalValueInfo: {
        textAlign: isDesktop ? 'right' : 'left',
        color: Colors.secondary
    },
    itemForTravel: {
        maxHeight: 34,
        flexDirection: 'row',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: Colors.secondary,
        borderRadius: Layout.radius,
        paddingVertical: Layout.gutterMin,
        paddingHorizontal: Layout.gutterSmall,
        justifyContent: 'space-between',
        marginLeft: Layout.gutter
    },

    qtProdutoView: {
        flexDirection: 'row',
        alignItems: 'center'
    },

    footer: {
        marginHorizontal: Layout.isDesktop ? Layout.gutter : 0,
        paddingVertical: Layout.isDesktop ? Layout.gutter : Layout.gutterSmall,
        borderTopWidth: 1,
        borderTopColor: Colors.border,
        backgroundColor: Colors.white,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    footerItem: {
        flexDirection: Layout.isDesktop ? 'row' : 'column',
        minWidth: Layout.isDesktop ? 80 : 50,
        height: Layout.isDesktop ? 30 : 36,
        paddingHorizontal: Layout.isDesktop ? 0 : Layout.gutter,
        marginBottom: Layout.isDesktop ? 0 : Layout.gutterSmall
    },
    footerLabel: {
        flex: 1,
        fontSize,
        lineHeight: fontSize * 2,
        color: Colors.dark
    },
    footerPrice: {
        paddingLeft: Layout.isDesktop ? Layout.gutter : 0,
        flexDirection: 'row'
    },
    footerPriceText: {
        fontSize,
        lineHeight: fontSize * 2,
        color: Colors.secondary
    },
    emptyState: {
        flex: 1,
        padding: Layout.gutter,
        justifyContent: 'center',
        alignItems: 'center'
    },
    emptyStateText: {
        textAlign: 'center'
    },
    flexRow: {
        flexDirection: 'row'
    }
});

const StyledInput = styled.input`
    width: 70px;
    height: 14px;
    color: ${Colors.dark};
    padding-left: ${Layout.gutterMin + 'px'};
    padding-right: ${Layout.gutterMin + 'px'};
    padding-top: 3px;
    padding-bottom: 3px;
    border: 1px solid ${Colors.border};
    border-radius: ${Layout.gutterMin + 'px'};
    font-size: 14px;
    text-align: right;
`;

export { StyledInput };
